// ABOUTME: Client-side owner token generation and per-pennant ownership map
// ABOUTME: One token per browser, reused across sessions; maps pennant IDs to tokens

const TOKEN_KEY = 'hopp.owner.token';
const MAP_KEY = 'hopp.owner.map';

function generateToken() {
    const bytes = new Uint8Array(16);
    if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
        crypto.getRandomValues(bytes);
    } else {
        // Fallback for test environments without Web Crypto
        for (let i = 0; i < bytes.length; i++) {
            bytes[i] = Math.floor(Math.random() * 256);
        }
    }
    return btoa(String.fromCharCode(...bytes))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
}

export function getOwnerToken() {
    try {
        let token = localStorage.getItem(TOKEN_KEY);
        if (!token) {
            token = generateToken();
            localStorage.setItem(TOKEN_KEY, token);
        }
        return token;
    } catch {
        return generateToken();
    }
}

export function clearOwnerToken() {
    try {
        localStorage.removeItem(TOKEN_KEY);
    } catch {
        // ignore
    }
}

function readMap() {
    try {
        const raw = localStorage.getItem(MAP_KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? parsed : {};
    } catch {
        return {};
    }
}

function writeMap(map) {
    try {
        localStorage.setItem(MAP_KEY, JSON.stringify(map));
    } catch {
        // ignore
    }
}

export function recordPennantOwnership(pennantId, ownerToken) {
    if (!pennantId || !ownerToken) return;
    const map = readMap();
    map[pennantId] = ownerToken;
    writeMap(map);
}

export function isOwnedPennant(pennantId) {
    if (!pennantId) return false;
    const token = getOwnerToken();
    const map = readMap();
    return map[pennantId] === token;
}

export function prunePennantOwnership(knownIds) {
    if (!knownIds || knownIds.size === 0) return;
    const map = readMap();
    let changed = false;
    for (const id of Object.keys(map)) {
        if (!knownIds.has(id)) {
            delete map[id];
            changed = true;
        }
    }
    if (changed) writeMap(map);
}

export function getOwnershipMap() {
    return readMap();
}
